const HtmlFireIcon = () => {
  return <>&#128293;</>
}

export default HtmlFireIcon
